export default __webpack_public_path__ + "static/media/logo.3e3f4a2a.png";